/**
 * SIL-2488 (counsel condition c1): every customer surface that shows escrow names the LICENSED escrow agent and never
 * presents SiliconX as holding, releasing, refunding or forfeiting funds. This is the one source for that disclosure.
 *
 * Source of the numbers: Escrow.com's own "Licenses and Complaints" page, https://www.escrow.com/escrow-licenses,
 * read 2026-11-03. California escrow licence is issued by the Department of Financial Protection and Innovation
 * (DFPI), number 9631867 as the page prints it; NMLS unique identifier 1370002; licensee Internet Escrow Services, Inc.
 * (https://www.escrow.com/escrow-license, the URL in the issue, returns 404; the footer link goes to /escrow-licenses.)
 */
export const ESCROW_AGENT = {
  name: 'Escrow.com',
  legalEntity: 'Internet Escrow Services, Inc.',
  californiaRegulator: 'California Department of Financial Protection and Innovation (DFPI)',
  californiaLicenseNumber: '9631867',
  nmlsId: '1370002',
  licenseUrl: 'https://www.escrow.com/escrow-licenses',
  sourceReadOn: '2026-11-03',
} as const;

/** Sentence naming the agent and its licences. No link; surfaces add the link separately (or use the plain-text form). */
export const ESCROW_AGENT_DISCLOSURE_TEXT =
  `Escrow services are provided by ${ESCROW_AGENT.name} (${ESCROW_AGENT.legalEntity}), licensed by the ` +
  `${ESCROW_AGENT.californiaRegulator}, licence ${ESCROW_AGENT.californiaLicenseNumber}, NMLS ${ESCROW_AGENT.nmlsId}.`;

/** The role split counsel requires: the agent holds and disburses; SiliconX only passes status updates. */
export const ESCROW_AGENT_ROLE_TEXT =
  `${ESCROW_AGENT.name} holds and disburses funds under the parties' escrow instructions. SiliconX does not hold, ` +
  `release, refund or forfeit funds and only sends status updates to ${ESCROW_AGENT.name}.`;

/** Link label for the licence page. */
export const ESCROW_AGENT_LICENSE_LINK_LABEL = `${ESCROW_AGENT.name} licences`;

/** Single-string form for plain-text surfaces (notifications, emails): disclosure plus the licence page URL. */
export const ESCROW_AGENT_DISCLOSURE_PLAIN = `${ESCROW_AGENT_DISCLOSURE_TEXT} Licences: ${ESCROW_AGENT.licenseUrl}`;
